import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

function EditAppUser() {
    const navigate = useHistory();
    const userId = parseInt(localStorage.getItem("AppUserEditId"));
    const userEmail = localStorage.getItem("AppUserEditEmail");

    const [cases, setCases] = useState([]);
    const [allCases, setAllCases] = useState([]);
    const [newPassword, setNewPassword] = useState("");
    const [selectedCaseId, setSelectedCaseId] = useState("");
    const [maxChars, setMaxChars] = useState(500);
    const [resetInterval, setResetInterval] = useState("Daily");
    const [updateCaseId, setUpdateCaseId] = useState("");
    const [newMaxChars, setNewMaxChars] = useState("");
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const getToken = () => {
        try {
            const raw = localStorage.getItem("state");
            if (raw) return JSON.parse(raw).auth?.token;
        } catch (e) { }
        return null;
    };

    useEffect(() => {
        const token = getToken();
        const headers = { ...(token && { Authorization: `Bearer ${token}` }) };
        Promise.all([
            axios.get(`${process.env.REACT_APP_API_URL}/AppUser/GetAllAppUsers`, { headers }),
            axios.get(`${process.env.REACT_APP_API_URL}/GetAllNewPatient?portalId=25`)
        ]).then(([usersRes, casesRes]) => {
            const user = (usersRes.data || []).find(u => (u.id || u.Id) === userId);
            setCases((user?.cases || user?.Cases || []));
            setAllCases(casesRes.data || []);
        }).catch(err => console.error(err))
            .finally(() => setIsLoading(false));
    }, []);

    const changePassword = (e) => {
        e.preventDefault();
        setLoading(true);
        const token = getToken();
        axios.post(`${process.env.REACT_APP_API_URL}/AppUser/AdminChangePassword`,
            { UserId: userId, NewPassword: newPassword },
            { headers: { "Content-Type": "application/json", ...(token && { Authorization: `Bearer ${token}` }) } }
        ).then(() => {
            Swal.fire({ title: "Success", text: "Password updated.", icon: "success", confirmButtonText: "Ok" });
            setNewPassword("");
        }).catch(err => {
            Swal.fire({ title: "Error", text: err.response?.data || "Failed", icon: "error", confirmButtonText: "Ok" });
        }).finally(() => setLoading(false));
    };

    const deactivateCase = (patientId) => {
        const token = getToken();
        Swal.fire({
            title: "Deactivate this case?",
            text: "The user will lose access until reactivated.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, deactivate"
        }).then(result => {
            if (!result.isConfirmed) return;
            axios.post(`${process.env.REACT_APP_API_URL}/AppUser/DeactivateCase`,
                { UserId: userId, Patient_Id: patientId },
                { headers: { "Content-Type": "application/json", ...(token && { Authorization: `Bearer ${token}` }) } }
            ).then(() => {
                Swal.fire({ title: "Done", icon: "success", confirmButtonText: "Ok" })
                    .then(() => window.location.reload());
            }).catch(err => {
                Swal.fire({ title: "Error", text: err.response?.data || "Failed", icon: "error", confirmButtonText: "Ok" });
            });
        });
    };

    const assignCase = (e) => {
        e.preventDefault();
        setLoading(true);
        const token = getToken();
        axios.post(`${process.env.REACT_APP_API_URL}/AppUser/PurchaseCase`,
            { Email: userEmail, Patient_Id: parseInt(selectedCaseId), Max_Characters: parseInt(maxChars), Reset_Interval: resetInterval },
            { headers: { "Content-Type": "application/json", "X-Api-Key": localStorage.getItem("EcomKey") || "", ...(token && { Authorization: `Bearer ${token}` }) } }
        ).then(() => {
            Swal.fire({ title: "Success", text: "Case assigned.", icon: "success", confirmButtonText: "Ok" })
                .then(() => window.location.reload());
        }).catch(err => {
            Swal.fire({ title: "Error", text: err.response?.data || "Failed", icon: "error", confirmButtonText: "Ok" });
        }).finally(() => setLoading(false));
    };

    const updateLimit = (e) => {
        e.preventDefault();
        setLoading(true);
        const token = getToken();
        axios.post(`${process.env.REACT_APP_API_URL}/AppUser/UpdateCaseLimit`,
            { Email: userEmail, Patient_Id: parseInt(updateCaseId), New_Max_Characters: parseInt(newMaxChars) },
            { headers: { "Content-Type": "application/json", "X-Api-Key": localStorage.getItem("EcomKey") || "", ...(token && { Authorization: `Bearer ${token}` }) } }
        ).then(() => {
            Swal.fire({ title: "Success", text: "Limit updated.", icon: "success", confirmButtonText: "Ok" })
                .then(() => window.location.reload());
        }).catch(err => {
            Swal.fire({ title: "Error", text: err.response?.data || "Failed", icon: "error", confirmButtonText: "Ok" });
        }).finally(() => setLoading(false));
    };

    if (isLoading) return (
        <div className="page-content-wrapper">
            <div className="page-content d-flex justify-content-center align-items-center">
                <div className="my-wrapper">
                    <div className="spinner center">
                        {[...Array(12)].map((_, i) => <div key={i} className="spinner-blade" />)}
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="page-content-wrapper">
            <div className="page-content">
                <div className="page-bar">
                    <div className="page-title-breadcrumb">
                        <div className="pull-left"><div className="page-title">Edit User: {userEmail}</div></div>
                        <div className="pull-right">
                            <button className="btn" style={{ backgroundColor: "#1e2b38", color: "#FFF" }}
                                onClick={() => navigate.push("/AppUserList")}>
                                <i className="fa fa-arrow-left" />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row">

                    {/* Change Password */}
                    <div className="col-md-6 mb-4">
                        <div className="card card-box">
                            <div className="card-head"><header>Change Password</header></div>
                            <div className="card-body">
                                <form onSubmit={changePassword}>
                                    <div className="form-group mb-3">
                                        <label className="control-label">New Password</label>
                                        <input type="password" className="form-control" value={newPassword}
                                            onChange={e => setNewPassword(e.target.value)} required minLength={6} />
                                    </div>
                                    <button type="submit" className="btn btn-primary" disabled={loading}>Update Password</button>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Current Cases */}
                    <div className="col-md-6 mb-4">
                        <div className="card card-box">
                            <div className="card-head"><header>Assigned Cases</header></div>
                            <div className="card-body">
                                {cases.length === 0
                                    ? <p style={{ color: "#999" }}>No cases assigned.</p>
                                    : (
                                        <table className="table table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50px" }}>ID</th>
                                                    <th>Case Name</th>
                                                    <th style={{ width: "70px" }}>Limit</th>
                                                    <th style={{ width: "60px" }}>Used</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cases.map(c => {
                                                    const pid = c.patient_Id || c.Patient_Id;
                                                    const max = c.max_Characters || c.Max_Characters;
                                                    const used = c.used_Characters || c.Used_Characters;
                                                    const active = c.active_Status ?? c.Active_Status;
                                                    const caseName = allCases.find(ac => String(ac.p_id) === String(pid));
                                                    return (
                                                        <tr key={pid}>
                                                            <td>{pid}</td>
                                                            <td>{caseName ? (caseName.patient_Nm || caseName.patient_Name || caseName.patientName || String(pid)) : String(pid)}</td>
                                                            <td>{max}</td>
                                                            <td>{used}</td>
                                                            <td>
                                                                <span style={{ backgroundColor: active ? "#28a745" : "#dc3545", color: "#fff", padding: "2px 8px", borderRadius: "4px", fontSize: "12px" }}>
                                                                    {active ? "Active" : "Inactive"}
                                                                </span>
                                                                {active && (
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        style={{ marginLeft: "8px" }}
                                                                        onClick={() => deactivateCase(pid)}
                                                                    >
                                                                        Deactivate
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    {/* Assign New Case */}
                    <div className="col-md-6 mb-4">
                        <div className="card card-box">
                            <div className="card-head"><header>Assign Case</header></div>
                            <div className="card-body">
                                <form onSubmit={assignCase}>
                                    <div className="form-group mb-3">
                                        <label className="control-label">Case</label>
                                        <select className="form-control" value={selectedCaseId}
                                            onChange={e => setSelectedCaseId(e.target.value)} required>
                                            <option value="">-- Select Case --</option>
                                            {allCases
                                                .filter(c => (c.portal_Id || c.portalId || c.Portal_Id) === 25)
                                                .map(c => (
                                                    <option key={c.p_id} value={c.p_id}>
                                                        {c.patient_Nm || c.patient_Name || c.patientName || c.p_id}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="control-label">Daily Character Limit</label>
                                        <input type="number" className="form-control" value={maxChars}
                                            onChange={e => setMaxChars(e.target.value)} min={1} required />
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="control-label">Reset Interval</label>
                                        <select className="form-control" value={resetInterval}
                                            onChange={e => setResetInterval(e.target.value)}>
                                            <option value="Daily">Daily</option>
                                            <option value="Weekly">Weekly</option>
                                        </select>
                                    </div>
                                    <button type="submit" className="btn btn-primary" disabled={loading}>Assign</button>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Update Case Limit */}
                    <div className="col-md-6 mb-4">
                        <div className="card card-box">
                            <div className="card-head"><header>Update Case Limit</header></div>
                            <div className="card-body">
                                <form onSubmit={updateLimit}>
                                    <div className="form-group mb-3">
                                        <label className="control-label">Case</label>
                                        <select className="form-control" value={updateCaseId}
                                            onChange={e => setUpdateCaseId(e.target.value)} required>
                                            <option value="">-- Select Case --</option>
                                            {cases
                                                .filter(c => (c.active_Status ?? c.Active_Status) === true)
                                                .map(c => {
                                                    const pid = c.patient_Id || c.Patient_Id;
                                                    const match = allCases.find(ac => String(ac.p_id) === String(pid));
                                                    const name = match ? (match.patient_Nm || match.patient_Name || match.patientName || String(pid)) : String(pid);
                                                    return <option key={pid} value={pid}>{name}</option>;
                                                })}
                                        </select>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="control-label">New Daily Limit</label>
                                        <input type="number" className="form-control" value={newMaxChars}
                                            onChange={e => setNewMaxChars(e.target.value)} min={1} required />
                                    </div>
                                    <button type="submit" className="btn btn-primary" disabled={loading}>Update Limit</button>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default EditAppUser;